import { Box, Typography } from "@mui/material";
import { businessListStyles } from "styles/BusinessListDirectory/listHeader.styles";

const CreateListHeader = () => {
  return (
    <Box sx={businessListStyles.createHeaderContainer}>
      <Box>
        <Typography sx={businessListStyles.headerTitle}>
          Create New List
        </Typography>

        <Typography sx={businessListStyles.underlineHeading}>
          Create a List of businesses to share with your customers
        </Typography>
      </Box>
    </Box>
  );
};

export default CreateListHeader;
